import React, { useEffect } from "react";
import withSSR from "../../withSSR";
import "./PaymentMethodsHome.scss";
import MenuDataService from "../../services/MenuDataService";
import GeneralDataService from "../../services/GeneralDataService";
import Header from "../../organisms/Header/Header";
import Footer from "../../organisms/Footer/Footer";
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { useStore } from "../../hooks/store";
import AgrofyPaymentMethodsPrincipal from "../../organisms/AgrofyPaymentMethodsPrincipal/AgrofyPaymentMethodsPrincipal";
import { getPaymentData } from "../../services/getPaymentData";
import { GtmInitialize, TrackPaymentMethodsPageView } from '../../services/gtmEvents';


const PaymentMethodsHome = (props) => {
  const initialData = props && props.initialData;
  const info = props && props.info;
  const baseUrl = process.env.RAZZLE_BASE_URL || window.env.RAZZLE_BASE_URL;
  const paymentMethodsUrl = process.env.PAYMENT_METHODS_URL || window.env.PAYMENT_METHODS_URL;
  const {t} = useTranslation();
  const [state, dispatch] = useStore();

  useEffect(() => {
    dispatch("SET_WINDOWWIDTH", window.innerWidth);
    window.addEventListener("resize", () => {
      dispatch("SET_WINDOWWIDTH", window.innerWidth);
    });
  }, []);

  useEffect(() => {
    TrackPaymentMethodsPageView();
    setTimeout(function () {
      GtmInitialize();
    }, 3000);
  }, []); 

  useEffect(() => {
    dispatch("SET_PAYMENT_METHODS_DATA", initialData);
    if (state && state.isMobile == false) {
      dispatch(
        "SET_SELECTED_PAYMENT_CATEGORY",
        initialData[0]
      );
      dispatch(
        "SET_SELECTED_PAYMENT_METHOD",
        initialData[0]?.PaymentMethodTypes[0]
      );
    }
  }, [state.isMobile]);


  return (
    <React.Fragment>
      <Helmet>
        <title>{t('payment_methods_title')}</title>
        <meta name="description" content={t('payment_methods_description')} />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href={`${baseUrl}${paymentMethodsUrl}`}/>
      </Helmet>
      <Header />
      <div className="page-content">
        <AgrofyPaymentMethodsPrincipal />
      </div>
      <Footer footerData={info.staticData} />
    </React.Fragment>
  );
};

// Server side rendering example
PaymentMethodsHome.getInitialProps = async ({ match, req, res }) => {
  try {
    const data = await getPaymentData();
    const menuData = await MenuDataService();
    const staticData = GeneralDataService();

    return {
      initialData: data,
      info: {
        menuData: menuData.data,
        staticData,
      },
    };
  } catch (e) {
    return console.error(e);
  }
};

export default withSSR(PaymentMethodsHome);
